<template>
    <section class="login-bg">
        <v-container>
            <v-row class="d-flex justify-center align-center mt-16">
                <v-col cols="12" md="4">
                    <div class="d-flex flex-column align-center mt-6">
                        <v-img class="w-50 ml-n1" src="../assets/maherco-logo.png"></v-img>
                        <div class="text-h5 mx-4" style="font-family: Angkor, serif; color: #FFFFFF">Welcome Admin</div>
                        <div class="mt-4" style="font-family: Angkor, serif; color: #FFFFFF">Sign in to continue access</div>
                    </div>
                </v-col>
                <v-col cols="12" md="5" class="mt-10">
                    <v-form ref="Formref" @submit.prevent="dologin">
                        <v-card height="350" rounded="xl" elevation="6" color="secondary" class="card-bg d-flex">
                            <v-container>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-menu offset-y>
                                            <template v-slot:activator="{ props }">
                                                <v-btn v-bind="props" elevation="0" class="bg-transparent">
                                                    <v-avatar size="24" class="mr-2">
                                                        <v-img :src="selectedFlag" />
                                                    </v-avatar>
                                                    <span class="ml-2">{{ selectedLanguage }}</span>
                                                </v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-item v-for="lang in languages" :key="lang.code" @click="changeLanguage(lang)">
                                                    <v-list-item-title class="d-flex align-center">
                                                        <v-avatar size="24" class="mr-2">
                                                            <v-img :src="lang.flag"></v-img>
                                                        </v-avatar>
                                                        {{ lang.name }}
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-col>

                                    <!-- Username Field -->
                                    <v-col cols="12" class="mt-16 px-8">
                                        <v-row align="center" justify="space-between">
                                            <v-col cols="4">
                                                <div class="text-h6" style="font-family: Saira Condensed, sans-serif; color: #FFFFFF;">
                                                    {{ $t('LoginLabels.Username') }}:
                                                </div>
                                            </v-col>
                                            <v-col cols="8">
                                                <v-text-field
                                                    v-model="username"
                                                    :rules="[formRules.required]"
                                                    variant="solo"
                                                    bg-color="#FFFFFF"
                                                    type="email"
                                                    class="text-h6"
                                                    density="compact"
                                                    style="font-family: Saira Condensed, sans-serif;"
                                                    @keydown.enter="dologin"
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>

                                    <!-- Password Field -->
                                    <v-col cols="12" class="px-8">
                                        <v-row align="center" justify="space-between">
                                            <v-col cols="4">
                                                <div class="text-h6" style="font-family: Saira Condensed, sans-serif; color: #FFFFFF;">
                                                    {{ $t('LoginLabels.Password') }}:
                                                </div>
                                            </v-col>
                                            <v-col cols="8">
                                                <v-text-field
                                                    v-model="password"
                                                    :rules="[formRules.required]"
                                                    variant="solo"
                                                    :append-inner-icon="showPass ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                                                    :type="showPass ? 'text' : 'password'"
                                                    @click:append-inner="showPass = !showPass"
                                                    bg-color="#FFFFFF"
                                                    class="text-h6"
                                                    density="compact"
                                                    style="font-family: Saira Condensed, sans-serif;"
                                                    @keydown.enter="dologin"
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>

                                    <!-- Login Button -->
                                    <v-col cols="12" class="text-center">
                                        <v-btn
                                            type="submit"
                                            :loading="loading"
                                            color="primary"
                                            height="40px"
                                            class="text-h6"
                                            style="font-family: Saira Condensed, sans-serif;"
                                        >
                                            {{ $t('Buttons.Login') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
            <v-row class="d-flex justify-center align-center">
                <v-col cols="12">
                    <div class="mt-4 text-subtitle-1 text-center" style="font-family: Angkor, serif; color: white;">IF YOU ARE A USER, PLEASE VISIT <a href="https://www.maherco.gg" style="text-decoration-line: none;"><span style="color: white;">MAHERCO.GG</span></a></div>
                </v-col>
            </v-row>
        </v-container>
    </section>
    <v-snackbar
        v-model="snackbar"
        :timeout="2500"
        color="secondary"
        location="top">
        <v-icon>mdi-alert-circle</v-icon>
        <span class="ml-2">{{ snackText }}</span>
    </v-snackbar>
</template>

<script>    
import axios from 'axios';
import { defineComponent } from 'vue';
export default defineComponent({
    data() {
        const languages = [
            { name: 'English', code: 'en', flag: require('@/assets/flags/uk.png') },
            { name: 'Arabic', code: 'ar', flag: require('@/assets/flags/uae.png') }
        ];
        const storedLang = localStorage.getItem('selectedLanguage') || 'en';
        const selectedLangObj = languages.find(lang => lang.code === storedLang) || languages[0];
        return {
            username: null,
            password: null,
            snackbar: false,
            snackText: null,
            showPass: false,
            loading: false,
            languages,
            selectedLanguage: selectedLangObj.name,
            selectedFlag: selectedLangObj.flag,
        }
    },  
    methods: {
        dologin() {
            if (this.$refs.Formref.validate()) {
                this.loading = true
                let data = {
                    username: this.username,
                    password: this.password
                };
                axios.post(process.env.VUE_APP_SERVER_URL + '/api/admin/auth/login', data, 
                { headers: 
                    { 
                        'Content-Type': 'application/json',
                        'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                    }
                } 
                ).then((res)=>{
                    this.loading = false
                    this.snackbar = true
                    this.snackText ='Logging in ...'
                    localStorage.setItem("maherco-admin-accesstoken", res.data.accessToken)
                    this.$store.commit('UPDATE_USER', res.data.user)
                    window.location.reload()
                }).catch((error) => {
                    if (error.response) {
                        if (error.response.status === 401) {
                            this.snackbar = true
                            this.snackText ='Wrong Credentials'
                            this.loading = false
                        } else {
                            console.log(`Error: ${error.response.status}`);
                            if(error.response.status == 400){
                                this.snackbar = true
                                this.snackText ='Wrong Credentials'
                                this.loading = false
                            }
                        }
                    } 
                    else if (error.request) {
                        console.log('No response received', error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            }
        },
        changeLanguage(lang) {
            this.selectedLanguage = lang.name;
            this.selectedFlag = lang.flag;

            localStorage.setItem('selectedLanguage', lang.code);
            this.locale = lang.code;
            window.location.reload();
        },
        redirectToGoogleAuth() {
        // Redirect the user to the Google OAuth2.0 authentication URL
        window.location.href = this.googleAuthURL;
        },
    },
})
</script>

<style  scoped>
@import url('https://fonts.googleapis.com/css2?family=Angkor&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Saira+Condensed:wght@100;200;300;400;500;600;700;800;900&display=swap');

.login-bg {
	background-image: url('../assets/bg-main.png');
	background-repeat: no-repeat;
	background-size: cover;
    
    height: 100vh;
}
</style>